import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/content";

export const Manifesto = () => {
  return (
    <section id="manifiesto" data-testid="manifesto-section" className="bg-[#0A1F10] text-white py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 mb-16 md:mb-24">
          <div className="md:col-span-3">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5AB82D]">
              Por qué elegirme
            </span>
          </div>
          <div className="md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="font-serif-display text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight leading-[1.08] text-white max-w-3xl"
            >
              La tranquilidad de poner tu hogar en manos de un profesional serio.
            </motion.h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 md:grid-rows-2 md:grid-flow-col gap-x-16">
          {MANIFESTO.map((item, i) => (
            <motion.div
              key={item.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="flex gap-5 md:gap-8 py-10 md:py-12 border-t border-white/10 group"
              data-testid={`manifesto-item-${i}`}
            >
              <div className="shrink-0">
                <span className="font-serif-display text-6xl md:text-7xl font-medium text-white/15 group-hover:text-[#5AB82D]/60 transition-colors duration-500">
                  {item.num}
                </span>
              </div>
              <div>
                <h3 className="font-serif-display text-2xl md:text-3xl font-semibold text-white mb-3">
                  {item.title}
                </h3>
                <p className="text-base leading-relaxed text-white/60">{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
